export default function(array) {
  return array[array.length - 1];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/node_modules/vega-util/src/peek.js
// module id = null
// module chunks = 